import api from '@/utils/api';
import {
    FETCH_PRODUCTS,
    FETCH_ACTIVE_PRODUCTS,
    FETCH_PRODUCT,
    CREATE_PRODUCT,
    UPDATE_PRODUCT,
    REMOVE_PRODUCTS,
    FETCH_PRODUCT_STATS,
    FETCH_INVENTORY_STATS,
    EXPORT_INVENTORY_STATS
} from './types';
import { NotificationManager } from 'react-notifications';

const PRODUCTS_ENDPOINT = '/products';

export const fetchProducts = (filter) => dispatch => {
    return api.get(PRODUCTS_ENDPOINT, { params: filter })
        .then(res => {
            dispatch({
                type: FETCH_PRODUCTS,
                payload: res.data.data
            });
            return res.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            throw err;
        });
};

export const fetchActiveProducts = (filter) => dispatch => {
    return api.get(`${PRODUCTS_ENDPOINT}/active`, { params: filter })
        .then(res => {
            dispatch({
                type: FETCH_ACTIVE_PRODUCTS,
                payload: res.data.data
            });
            return res.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            throw err;
        });
};

export const fetchProduct = (id) => dispatch => {
    return api.get(`${PRODUCTS_ENDPOINT}/${id}`)
        .then(res => {
            dispatch({
                type: FETCH_PRODUCT,
                payload: res.data.data
            });
            return res.data.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            throw err;
        });
};

export const createProduct = (data) => dispatch => {
    return api.post(PRODUCTS_ENDPOINT, data)
        .then(res => {
            dispatch({
                type: CREATE_PRODUCT,
                payload: res.data.data
            });
            return res.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            throw err;
        });
};

export const updateProduct = (id, data) => dispatch => {
    return api.put(`${PRODUCTS_ENDPOINT}/${id}`, data)
        .then(res => {
            dispatch({
                type: UPDATE_PRODUCT,
                payload: res.data.data
            });
            return res.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            throw err;
        });
};

export const removeProducts = (ids) => dispatch => {
    return api.delete(PRODUCTS_ENDPOINT, { data: { ids } })
        .then(res => {
            dispatch({
                type: REMOVE_PRODUCTS,
                payload: ids
            });
            NotificationManager.success("Xoá thành công!");
            return res.data.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            throw err;
        });
};

export const fetchProductStats = (filter) => dispatch => {
    return api.get(`${PRODUCTS_ENDPOINT}/statistics/total`, { params: filter })
        .then(res => {
            dispatch({
                type: FETCH_PRODUCT_STATS,
                payload: res.data.data
            });
            return res.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            throw err;
        });
};

export const fetchInventoryStats = (filter) => dispatch => {
    return api.get(`${PRODUCTS_ENDPOINT}/statistics/inventory`, { params: filter })
        .then(res => {
            dispatch({
                type: FETCH_INVENTORY_STATS,
                payload: res.data.data
            });
            return res.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            throw err;
        });
};

export const exportInventoryStats = (filter) => dispatch => {
    return api.post(`${PRODUCTS_ENDPOINT}/statistics/inventory/export`, filter)
        .then(res => {
            dispatch({
                type: EXPORT_INVENTORY_STATS,
                payload: res.data.data
            });
            return res.data.data;
        })
        .catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            throw err;
        });
};